import { DonationFlowCustomizationResponse } from "@every.org/common/src/codecs/donationFlowCustomization";

import { DonationFlowCustomizationFormData } from "src/components/CustomizeDonationExperience/types";
import { ContextNonprofit } from "src/context/NonprofitsContext/types";

export interface AdminSidebarContextType {
  visible: boolean;
  enabled: boolean;
}

export interface DonationFlowCustomizationContextType {
  loading: boolean;
  saving: boolean;
  hasNoExistingCustomization: boolean;
  errorMessage: string | null;
  value: DonationFlowCustomizationResponse | null;
}

export interface SaveDonationFlowCustomizationArgs {
  values: DonationFlowCustomizationFormData;
  nonprofit: ContextNonprofit;
  setError: (
    field: keyof DonationFlowCustomizationFormData,
    error: { message: string }
  ) => void;
}

export type NonprofitAdminPageState = {
  sidebar: AdminSidebarContextType;
  donationFlowCustomization: DonationFlowCustomizationContextType;
};

export enum NonprofitAdminPageContextActionType {
  SHOW_SIDEBAR = "SHOW_SIDEBAR",
  HIDE_SIDEBAR = "HIDE_SIDEBAR",
  TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR",
  ENABLE_SIDEBAR = "ENABLE_SIDEBAR",
  DISABLE_SIDEBAR = "DISABLE_SIDEBAR",
  FETCH_DONATION_FLOW_CUSTOMIZATION_START = "FETCH_DONATION_FLOW_CUSTOMIZATION_START",
  FETCH_DONATION_FLOW_CUSTOMIZATION_SUCCESS = "FETCH_DONATION_FLOW_CUSTOMIZATION_SUCCESS",
  FETCH_DONATION_FLOW_CUSTOMIZATION_ERROR = "FETCH_DONATION_FLOW_CUSTOMIZATION_ERROR",
  SAVE_DONATION_FLOW_CUSTOMIZATION_START = "SAVE_DONATION_FLOW_CUSTOMIZATION_START",
  SAVE_DONATION_FLOW_CUSTOMIZATION_SUCCESS = "SAVE_DONATION_FLOW_CUSTOMIZATION_SUCCESS",
  SAVE_DONATION_FLOW_CUSTOMIZATION_ERROR = "SAVE_DONATION_FLOW_CUSTOMIZATION_ERROR",
}

export type NonprofitAdminPageContextAction =
  | { type: NonprofitAdminPageContextActionType.SHOW_SIDEBAR }
  | { type: NonprofitAdminPageContextActionType.HIDE_SIDEBAR }
  | { type: NonprofitAdminPageContextActionType.TOGGLE_SIDEBAR }
  | { type: NonprofitAdminPageContextActionType.ENABLE_SIDEBAR }
  | { type: NonprofitAdminPageContextActionType.DISABLE_SIDEBAR }
  | {
      type: NonprofitAdminPageContextActionType.FETCH_DONATION_FLOW_CUSTOMIZATION_START;
    }
  | {
      type: NonprofitAdminPageContextActionType.FETCH_DONATION_FLOW_CUSTOMIZATION_SUCCESS;
      customization: DonationFlowCustomizationResponse | null;
    }
  | {
      type: NonprofitAdminPageContextActionType.FETCH_DONATION_FLOW_CUSTOMIZATION_ERROR;
      errorMessage: string;
    }
  | {
      type: NonprofitAdminPageContextActionType.SAVE_DONATION_FLOW_CUSTOMIZATION_START;
    }
  | {
      type: NonprofitAdminPageContextActionType.SAVE_DONATION_FLOW_CUSTOMIZATION_SUCCESS;
      customization: DonationFlowCustomizationResponse;
    }
  | {
      type: NonprofitAdminPageContextActionType.SAVE_DONATION_FLOW_CUSTOMIZATION_ERROR;
      errorMessage: string;
    };
